// extracted by mini-css-extract-plugin
module.exports = {"screen":"Subscriptions_screen__2_-2K"};